<template>
  <v-menu offset-y :close-on-content-click="false" v-model="isShown">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="notSelectedOption"
        class="px-2 no-transform-text"
        text
        v-bind="attrs"
        v-on="on"
      >
        <span
          class="newTitle--text text-subtitle-1"
          v-if="!selectedItems.length"
        >
          <span>{{ $t('message.pages.analytics.allVideos') }} </span>
        </span>
        <span class="newTitle--text text-subtitle-1 text-capitalize" v-else>
          {{ selectedItems.length }}
          {{ selectedItems.length > 1 ? 'Selecionados' : 'Selecionado' }}
        </span>
        <v-icon class="elevation-0 pl-2" color="primary">
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <v-card width="580px" height="394px">
      <v-card-text style="height: 334px" class="pa-0">
        <v-row no-gutters>
          <!-- <v-col cols="12" class="px-4">
            <v-text-field
              dense
              outlined
              label="Buscar por vídeo ou pasta"
              prepend-inner-icon="mdi-magnify"
              hide-details
            ></v-text-field>
          </v-col> -->
          <v-col cols="12">
            <v-toolbar elevation="0" class="mr-5 my-2" dense>
              <template v-if="isNamesTooBig">
                <v-menu offset-y max-width="250">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="ml-2"
                    >
                      <v-icon class="elevation-0" color="primary">
                        mdi-package-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in reducedBreadcrumbArray"
                      :key="index"
                      @click="handleBackTo(item)"
                      dense
                    >
                      <v-list-item-title
                        :title="item.id ? item.name : $t('message.videos')"
                      >
                        <span class="subtitle-2">
                          <v-icon class="mr-2 pb-1" color="primary">
                            {{ item.id ? 'mdi-folder-outline' : 'mdi-home' }}
                          </v-icon>
                          {{ item.id ? item.name : $t('message.videos') }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-icon>mdi-chevron-right</v-icon>
                <button
                  v-if="!selectedFolder"
                  type="button"
                  class="primary--text"
                  @click="handleBackTo(lastBreadcrumbItem)"
                >
                  <span class="breadcrumbTexts primary--text">
                    {{
                      lastBreadcrumbItem.id
                        ? lastBreadcrumbItem.name
                        : $t('message.videos')
                    }}
                  </span>
                </button>
                <button v-else type="button" class="primary--text">
                  <span class="breadcrumbTexts primary--text">
                    {{ selectedFolder.name }}
                  </span>
                </button>
              </template>
              <template v-else>
                <small v-for="(item, i) in breadcrumbArray" :key="i">
                  <button
                    type="button"
                    class="primary--text"
                    @click="handleBackTo(item)"
                  >
                    <span class="breadcrumbTexts primary--text">
                      {{ item.id ? item.name : $t('message.videos') }}
                      <v-icon v-if="i < breadcrumbArray.length - 1">
                        mdi-chevron-right
                      </v-icon>
                    </span>
                  </button>
                </small>
                <small>
                  <v-icon v-if="!!selectedFolder">mdi-chevron-right</v-icon>
                  <button
                    v-if="!!selectedFolder"
                    type="button"
                    class="primary--text"
                  >
                    <span class="breadcrumbTexts primary--text">
                      {{ selectedFolder.name }}
                    </span>
                  </button>
                </small>
              </template>
            </v-toolbar>
          </v-col>
          <v-col cols="12">
            <vue-virtual-table
              v-if="allItems.length > 0"
              class="searchVideosMenuTable"
              :config="headers"
              :data="allItems"
              :height="300"
              :itemHeight="40"
              :minWidth="500"
            >
              <template slot-scope="scope" slot="select">
                <v-row no-gutters align="center" justify="end">
                  <v-simple-checkbox
                    class="pl-3"
                    color="primary"
                    :ripple="false"
                    :value="checkIfSelected(scope.row)"
                    @input="checkboxSelection(scope.row)"
                  ></v-simple-checkbox>
                </v-row>
              </template>
              <template slot-scope="scope" slot="titleCommon">
                <v-row
                  no-gutters
                  align="center"
                  class="searchVideosMenuContext pl-2 flex-nowrap"
                  @click="handleEnterFolder(scope.row)"
                >
                  <v-icon :color="scope.row.name ? 'primary' : ''">
                    {{ scope.row.name ? 'mdi-folder' : 'mdi-play-box-outline' }}
                  </v-icon>
                  <span
                    class="pt-1 pl-1 text-truncate"
                    :title="scope.row.name ? scope.row.name : scope.row.title"
                  >
                    {{ scope.row.name ? scope.row.name : scope.row.title }}
                  </span>
                </v-row>
              </template>
              <template slot-scope="scope" slot="search">
                <v-row
                  no-gutters
                  align="center"
                  class="searchVideosMenuContext"
                  @click="handleEnterFolder(scope.row)"
                >
                  <v-icon
                    v-if="scope.row.name"
                    @click="handleEnterFolder(scope.row)"
                  >
                    mdi-chevron-right
                  </v-icon>
                </v-row>
              </template>
            </vue-virtual-table>
            <v-card
              v-else
              flat
              height="250px"
              width="100%"
              class="d-flex flex-row align-center justify-center"
            >
              <v-card-text class="text-center">
                <v-icon class="mb-2 mr-1" color="primary">
                  mdi-folder-search-outline
                </v-icon>
                <span class="subtitle-2">{{
                  $t('message.pages.analytics.account.notFound')
                }}</span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn color="primary" outlined @click="handleEmitAll">{{
          $t('message.pages.analytics.allVideos')
        }}</v-btn>
        <v-btn
          :disabled="selectedItems.length < 1"
          color="primary"
          @click="handleFilterSelected"
          width="150px"
        >
          <span class="px-2">Filtrar ({{ this.selectedItems.length }})</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import VueVirtualTable from 'vue-virtual-table'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'SearchVideosMenu',
  components: {
    VueVirtualTable,
  },
  props: {
    video_external_id: {
      type: [Number, String],
      default: '',
      required: false,
    },
  },
  data: () => ({
    isShown: false,
    selectedItems: [],
    allVideos: [],
    headers: [
      {
        prop: '_action',
        name: 'action',
        actionName: 'select',
        width: 40,
        alignItems: 'center',
        justifyContent: 'start',
      },
      {
        prop: '_action',
        name: 'title',
        actionName: 'titleCommon',
        alignItems: 'center',
        justifyContent: 'start',
      },
      {
        prop: '_action',
        name: 'goInto',
        actionName: 'search',
        width: 50,
        alignItems: 'center',
        justifyContent: 'start',
      },
    ],
    lastFolder: {
      name: '',
      id: null,
      parent_folder_id: null,
    },
    selectedFolder: null,
    breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
    filteredVideos: [],
  }),
  computed: {
    ...mapState('user', {
      folders: 'mainFolders',
    }),
    blockedRoute() {
      return this.$route.name === 'AnalyticsV2Devices'
    },
    reducedBreadcrumbArray() {
      let arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })
      if (this.selectedFolder) {
        return this.breadcrumbArray
      }
      return arrayMod
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
    isNamesTooBig() {
      let size = 0
      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }
      if (this.selectedFolder?.name) {
        size += this.selectedFolder.name.length
      }
      return size > 50
    },
    allItems() {
      return this.toBeSelectedFolders.concat(this.allVideos)
    },
    toBeSelectedFolders() {
      let selectedFolders = this.folders.filter((folder) => {
        return folder.parent_folder_id === this.lastFolder.id
      })
      return selectedFolders
    },
  },
  created() {
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    this.getVideos()
  },
  watch: {
    video_external_id() {
      this.filterByExternalID()
    },
  },
  methods: {
    async handleEmitAll() {
      this.selectedItems = []
      this.isShown = false
      this.$root.$emit('analyticsV2SearchAll')
    },
    async handleFilterSelected() {
      let isFilteredNoVideos = false
      let videos = []
      let folders = []
      for (let item of this.selectedItems) {
        if (item.name) {
          folders.push(item)
        } else {
          videos.push(item)
        }
      }
      this.filteredVideos = [...videos]
      let result = await this.getAllItems(folders)
      this.filteredVideos = this.filteredVideos.concat(result)
      if (this.filteredVideos.length === 0) isFilteredNoVideos = true
      this.$root.$emit(
        'filterSelected',
        this.filteredVideos,
        isFilteredNoVideos
      )
      this.filteredVideos = []
      this.isShown = false
    },
    async getAllItems(folders) {
      let items = []
      for (let item of folders) {
        if (item.name) {
          let vids = await window.db.videos
            .where({ folder_id: item.id })
            .toArray()
          items = items.concat(vids)
          let children = this.folders.filter(
            (folder) => folder.parent_folder_id === item.id
          )
          if (children.length) {
            await this.getAllItems(children)
          }
        }
      }
      return items
    },
    async handleEnterFolder(item) {
      if (!item.name) {
        this.checkboxSelection(item)
      } else {
        this.allVideos = await window.db.videos
          .where({ folder_id: item.id })
          .toArray()
        this.lastFolder = item
        this.breadcrumbArray.push(item)
      }
    },
    checkIfHasChildren(folder) {
      let anySon = this.folders.find(
        (item) => item.parent_folder_id === folder.id
      )
      return anySon
    },
    async handleBackTo(backToFolder) {
      if (backToFolder.id) {
        this.allVideos = await window.db.videos
          .where({ folder_id: backToFolder.id })
          .toArray()
      } else {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        this.getVideos()
      }
      this.selectedFolder = null
      this.lastFolder = backToFolder
      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
          backToFolder.id
      )
        return
      let index = this.breadcrumbArray.findIndex((folder) => {
        return folder.id === backToFolder.id
      })
      let newArr = this.breadcrumbArray.slice(0, index + 1)
      this.breadcrumbArray = newArr
    },
    async getVideos() {
      this.allVideos = await window.db.videos
        .where({ folder_id: 'root' })
        .toArray()

      this.filterByExternalID()
    },
    checkIfSelected(item) {
      let foundItem = this.selectedItems.find((searchedVideo) => {
        return searchedVideo.id === item.id
      })
      if (foundItem) return true
      return false
    },
    checkboxSelection(item) {
      let alreadySelected = this.checkIfSelected(item)
      if (alreadySelected) {
        let newArr = [
          ...this.selectedItems.filter((lookVideo) => {
            return lookVideo.id !== item.id
          }),
        ]
        this.selectedItems = [...newArr]
      } else {
        this.selectedItems.push(item)
      }
    },
    async filterByExternalID() {
      if (!this.video_external_id) return

      const option = { video_external_id: this.video_external_id }

      const [videoInDB] = await window.db.videos.where(option).toArray()
      const videoInRoot = _.find(this.allVideos, option)

      let video

      if (videoInRoot) video = videoInRoot
      else {
        this.allVideos.push(videoInDB)
        video = videoInDB
      }

      this.selectedItems = [video]

      this.handleFilterSelected()
    },
  },
}
</script>

<style lang="scss">
.selectedItemsText {
  font-weight: 400;
  font-size: 14px;
  color: #585d83;
}

.searchVideosMenuTable {
  overflow-x: hidden !important;
  background-color: var(--v-dark-newBackground);

  .item-line {
    background-color: var(--v-neutral-lighten4) !important;
  }

  .t-header {
    display: none;
  }

  .item-cell {
    border: none !important;
    padding: 0px !important;
  }
}

.searchVideosMenuContext {
  cursor: pointer;

  .text-truncate {
    max-width: 447px;
  }
}

.bg-dark {
  .searchVideosMenuTable {
    .item-line {
      background-color: var(--v-neutral-darken2) !important;
    }
  }
}

.v-btn.no-transform-text {
  text-transform: none !important;
}
</style>
